import React, {useState} from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { change_confirm_decision, close_confirm_modal, open_confirm_modal } from '../../../slices/Confirm_Modal/reducer';

const ConfirmModal = () => {

    // const [modal_center, setmodal_center] = useState(false);
    // function tog_center() {
    //     setmodal_center(!modal_center);
    // }

    const confirm_modal_slice = useSelector((state)=>state.Confirm_Modal_Slice)
    const dispatch = useDispatch()

  return (
    <>
    {/* <Button color="primary" onClick={() => tog_center()}>Center Modal</Button> */}
    <Modal
                isOpen={confirm_modal_slice.open_modal}
                // toggle={() => {
                //     if(confirm_modal_slice.open_modal){
                //         dispatch(close_confirm_modal())

                //     }else{
                //         dispatch(open_confirm_modal())
                //     }
                // }}
                centered
            >
                <ModalHeader className="modal-title" />

                <ModalBody className="text-center p-5">
                {/* <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon> */}
                    <i className='bx bx-error-alt' style={{ fontSize: "40px", color: "#8c68cd" }}></i>
                    {/* <lord-icon src="https://cdn.lordicon.com/hrqwmuhr.json"
                        trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: "120px", height: "120px" }}>
                    </lord-icon> */}
                    
                    <div className="mt-4">
                        <h4 className="mb-3">Are you Sure ?</h4>
                        <p className="text-muted mb-4"> { confirm_modal_slice.modal_message }</p>
                        <div className="hstack gap-2 justify-content-center">
                        <Button to="#" onClick={() => dispatch(change_confirm_decision(false))} className="btn btn-light">Cancel</Button>
                            <Button color="danger" onClick={() => dispatch(change_confirm_decision(true))}>Confirm</Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
      
    </>
  )
}

export default ConfirmModal
